export default __webpack_public_path__ + "static/media/Ellipse red (Stroke).864bd437.svg";